// nanoox/hooks/useCenterData.js
import { useEffect, useState ,useCallback, useRef  } from "react";
import { getCenterData } from "../services/nanooxService";
import { getFromCenterCache, saveToCenterCache, } from "../cache/centerCache";


// export function useCenterData({ region, area, centro, centerName, servidor }) {
//   const [centerData, setCenterData] = useState(null);
//   const [initialLoading, setInitialLoading] = useState(false);
//   const [refreshing, setRefreshing] = useState(false);
//   const [error, setError] = useState(null);

//   const requestIdRef = useRef(0);

//   const fetchData = useCallback(
//     async (isRefetch = false) => {
//       if (!servidor) {
//         setError("No se encontró servidor");
//         setInitialLoading(false);
//         return;
//       }

//       const finalRegion = region;
//       const finalArea = area;
//       const finalCentro = centro;
//       const finalCenterName = centerName;

//       if (!finalRegion || !finalArea || !finalCentro) {
//         setInitialLoading(false);
//         return;
//       }

//       const requestId = ++requestIdRef.current;

//       isRefetch ? setRefreshing(true) : setInitialLoading(true);

//       try {
//         const data = await getCenterData({
//           region: finalRegion,
//           area: finalArea,
//           centro: finalCentro,
//           centerName: finalCenterName,
//           serverUrl: servidor,
//         });

//         // ❌ descartar respuestas viejas
//         if (requestId !== requestIdRef.current) return;

//         setCenterData(data);
//         setError(null);
//       } catch (err) {
//         if (requestId !== requestIdRef.current) return;
//         setError(err.message);
//         setCenterData(null);
//       } finally {
//         if (requestId === requestIdRef.current) {
//           setInitialLoading(false);
//           setRefreshing(false);
//         }
//       }
//     },
//     [region, area, centro, centerName, servidor]
//   );

//   useEffect(() => {
//     console.log(
//       "%c🎯 useCenterData → fetch centro activo",
//       "color: purple; font-weight: bold",
//       { region, area, centro }
//     );
//     fetchData(false);
//   }, [fetchData]);

//   return {
//     centerData,
//     initialLoading,
//     refreshing,
//     error,
//     refetch: () => fetchData(true),
//   };
// }
export function useCenterData({ region, area, centro, centerName, servidor }) {
  const [centerData, setCenterData] = useState(null);
  const [initialLoading, setInitialLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState(null);

  const requestIdRef = useRef(0);

  const fetchData = useCallback(
    async (isRefetch = false) => {
      if (!servidor || !region || !area || !centro) {
        setInitialLoading(false);
        return;
      }

      const requestId = ++requestIdRef.current;

      // 🔹 CACHE HIT (solo si NO es refetch)
      if (!isRefetch) {
        const cached = getFromCenterCache({ region, area, centro: centerName || centro });
        if (cached) {
          // console.log(`⚡ [CACHE HIT - SINGLE] ${centro}`);
          setCenterData(cached);
          setInitialLoading(false);

          // 🔥 NUEVO: refrescar en background
          setTimeout(() => {
            fetchData(true);
          }, 0);

          return;
        }
      }


      isRefetch ? setRefreshing(true) : setInitialLoading(true);

      try {
        // console.log(`➡️ [GET CENTER] ${centro}`);

        const data = await getCenterData({
          region,
          area,
          centro,
          centerName,
          serverUrl: servidor,
        });

        if (requestId !== requestIdRef.current) return;

        saveToCenterCache({ region, area, centro: centerName || centro }, data);
        setCenterData(data);
        setError(null);

        // console.log(`✅ [GET CENTER OK] ${centro}`);
      } catch (err) {
        if (requestId !== requestIdRef.current) return;
        setError(err.message);
        setCenterData(null);
      } finally {
        if (requestId === requestIdRef.current) {
          setInitialLoading(false);
          setRefreshing(false);
        }
      }
    },
    [region, area, centro, centerName, servidor]
  );

  useEffect(() => {
    fetchData(false);
  }, [fetchData]);

  return {
    centerData,
    initialLoading,
    refreshing,
    error,
    refetch: () => fetchData(true),
  };
}

export function parseCenters(consolidado) {
  const centrosList = [];

  // recorrer las regiones
  for (const region of Object.keys(consolidado.regiones || {})) {
    // recorrer las áreas
    for (const areaKey of Object.keys(consolidado.areas || {})) {
      if (!areaKey.startsWith(region)) continue;

      // recorrer centros dentro del área
      const centros = consolidado.centros?.[areaKey] || {};
      for (const centroKey of Object.keys(centros)) {
        centrosList.push({
          region,
          area: areaKey.split("-")[1] || areaKey, // ej: "aysen-aysen" → "aysen"
          centro: centroKey.split("-")[0] || centroKey, // ej: "puntacola-aysen-aysen" → "puntacola"
        });
      }
    }
  }

  return centrosList;
}

export async function tipo_control(servidor) {
try {
    let SERVER_URL = servidor

    const Region = localStorage.getItem('REGION')
    const Area = localStorage.getItem('AREA')
    const Centro = localStorage.getItem('CENTRO')


    if (SERVER_URL === "Error en conexión") {
    console.error("No se pudo establecer una conexión con el servidor.");
    return {};
    }

    const endpoint = `/NANOOX/tipo_control/${Centro}/${Area}/${Region}`;
    const fullUrl = `${SERVER_URL}${endpoint}`;
    //console.log('fullUrl', fullUrl);

    const response = await fetch(fullUrl, {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json',
    },
    });

    //console.log('respuesta servidor', response);

    if (!response.ok) {
    throw new Error('Error en la solicitud');
    }

    const result = await response.json();
//   console.log('Respuesta del servidor:', result);

    return result; // Asegúrate de retornar el resultado aquí
} catch (error) {
    console.error('Error:', error);
    return {}; // Retorna un objeto vacío en caso de error
}
}
